export const V2 = 'V2';
export const V2_50 = 'V2_50';
export const V1 = 'V1';
export const V1KICKSTARTER = 'V1KICKSTARTER';
export const SOLO = 'SOLO';
export const DMU95 = 'DMU95';
